import { Container } from 'react-bootstrap';
import PageSectionTitle from '../Layout/PageSectionTitle';
import ResultsTable from './ResultsTable';
import "./ResultsTextContent.css";

const ResultsTextContent = (props) => {
  return(
    <div id="results-text-content">
      <Container fluid className="con-no-pad">
        <section id="section1">
          <PageSectionTitle>
            Results
          </PageSectionTitle>
          <p>
            We were delighted to receive 58 submissions. They were roughly evenly split on both (a) participation 
            in the patient-level track (Track 1, N≈1.2M observations per dataset) vs. the practice-level track (Track 2, N=2k) 
            and (b) the team's sector, either industry or academia.
          </p>
          <p>
            The submissions used diverse estimation approaches. They included parametric models (e.g. least squares regression), 
            semi-/non-parametric methods (e.g. gradient boosting machines), and ensembles thereof (e.g. SuperLearner). They also 
            included response surface models (e.g. BART), methods focused on selection into treatment (e.g. matching), and doubly 
            robust combinations of the two (e.g. AIPW).
          </p>
          <p>
            The table below lists the 58 method names and abbreviations, as given by the competitors. The 23 methods with an * are 
            unofficial post-competition entries. The figures below compare their performance on the root mean squared error (RMSE) 
            and 90% interval coverage for the overall treatment effect, averaging across all 3,400 datasets. The slide deck from our 
            presentation at ACIC 2022 is available <a href="./data/ACIC_data_challenge.pdf">here</a>: it reveals details of the DGP, 
            which were kept secret until now, and celebrates top-performing methods. Full results for each DGP setting, estimand, and 
            evaluation metric are available <a href="./data/ACIC_results.csv">here</a>. True treatment effects are available <a 
            href="./data/ACIC_estimand_truths.csv">here</a>.
          </p>
          <img id="results-plot-1" src="./images/webfig_1.png" alt="RMSE of Overall SATT"/>
          <img id="results-plot-2" src="./images/webfig_2.png" alt="Coverage of Overall SATT"/>
        </section>

        <section id='section2'>
          <PageSectionTitle>
            Method names
          </PageSectionTitle>
          <ResultsTable />
        </section>
      </Container>
    </div>
  )
}

export default ResultsTextContent;
